module.exports = __webpack_public_path__ + "static/media/icon_status_in.9ceb0f6c.svg";